import type { CSSProperties } from "react";

/** ターミナル・ファイル・機能タブで共有するタブ外枠の共通部分 (境界線・背景は各タブ側で足す)。 */
export function tabShellBaseStyle(active: boolean): CSSProperties {
	return {
		display: "inline-flex",
		alignItems: "center",
		alignSelf: "stretch",
		fontSize: "var(--text-caption)",
		whiteSpace: "nowrap",
		flexShrink: 0,
		fontWeight: active ? 600 : 500,
		color: active ? "var(--fg-0)" : "var(--fg-2)",
		cursor: "pointer",
		fontFamily: "inherit",
	};
}

/** ターミナルのタブ外枠のスタイル。 */
export function terminalTabShellStyle(active: boolean): CSSProperties {
	return {
		...tabShellBaseStyle(active),
		background: active ? "var(--surface-1)" : "transparent",
		border: "1px solid var(--line-1)",
		borderLeft: "none",
		borderTop: "none",
		borderBottom: active ? "1px solid var(--surface-1)" : "1px solid var(--line-1)",
		borderRadius: 0,
	};
}

/**
 * エディター・問題・モニター等の機能タブ用の外枠スタイル。タブ同士を区切る縦線・横線は
 * 引かず、アクティブなタブの下側にだけ線を引いて示す。
 */
export function functionTabShellStyle(active: boolean): CSSProperties {
	return {
		...tabShellBaseStyle(active),
		background: "transparent",
		border: "none",
		borderBottom: active ? "1px solid var(--fg-0)" : "1px solid transparent",
	};
}

export const tabLabelStyle: CSSProperties = {
	maxWidth: 160,
	overflow: "hidden",
	textOverflow: "ellipsis",
	whiteSpace: "nowrap",
	// タブのクリック・ドラッグでラベルが選択状態になるのを防ぐ。
	userSelect: "none",
};
